<template>
  <div class='filter' v-click-outside='closeDropdown'>
    <form class='default-filters'>
      <div v-for='filter in filterList' :key='filter' class='btn-group dropdown form-group' role='group' aria-expanded='false' ref='dropdown'>
        <button aria-expanded='false' aria-haspopup='true' data-toggle='dropdown'>
          {{ $t('root.filters.' + filter) }}
          <i class='fas fa-sort-down' aria-hidden='true'></i>
        </button>

        <div class='dropdown-menu'>
          <component :is="'filter-items-by-shared-' + filter" @cancel='closeDropdown' />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import _filter_items_by_shared_document from './_filter_by_shared_document_id'
import _filter_items_by_shared_product from './_filter_by_shared_product_id'
import _filter_items_by_shared_folder from './_filter_by_shared_folder_id'

export default {
  components: {
    'filter-items-by-shared-document': _filter_items_by_shared_document,
    'filter-items-by-shared-product': _filter_items_by_shared_product,
    'filter-items-by-shared-folders': _filter_items_by_shared_folder,
  },
  mounted() {
    $(this.$refs.dropdown).on('hide.bs.dropdown', () => {
      if (!this.isClosable)
        return false

      this.isClosable = false
      return true
    })
  },
  data() {
    return {
      isClosable: false,
    }
  },
  computed: {
    filterList() {
      return Object.freeze(['product', 'document', 'folders'])
    },
  },
  methods: {
    closeDropdown() {
      this.isClosable = true
    },
  },
}
</script>

<style lang='sass' scoped>
.filter
  display: flex
  margin-top: 10px
  .default-filters
    .dropdown
      > button
        background: none
        border: none
  .form-group
    margin-bottom: 0
    margin-right: 15px
  .dropdown-menu
    li
      color: #686868
      font-weight: 500
      padding-bottom: 5px
      a
        color: #686868
        font-weight: 500
    select
      border: 1px solid #ccc
      border-radius: 3px
      color: #686868
      font-weight: 500
      width: 100%
    label
      margin-bottom: 0
      padding: 5px 0 0
</style>
